import React, { useState, useEffect } from 'react';
import '../../App.css';
import '../../Styles/superset.css';
import SupersetService from '../../services/supersetservice';
import { SuperChart } from '@superset-ui/core';

const SuperSet = () => {
  const [value, setValue] = useState(0); // State to manage the active tab
  const [selectedChart, setSelectedChart] = useState(null);
  const [chartPayload, setChartPayload] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [chartData, setChartData] = useState([]);


  const dashboardIds = [
    // '7b5aa0ca-2b6e-4a5c-8cb9-fed22b66068f', // Patients
    '14b4698f-084c-4e00-91e7-3f8fc1060ac4', // Patients
    // '2ce16e1d-9693-4406-802b-dca6db144624', // cianacare
    '42186e2a-9d02-4852-8fe4-0966fa5bc10c', // cianacare
    '7e84e93a-678e-4ad1-ad25-0798f5cf1d18', // Appointments
    'another-dashboard-id', // cianaarex
    'another-dashboard-id', // Genetic wellness
  ];

  const handleChange = (index) => {
    setValue(index); // Update the active tab index
  };

  useEffect(() => {
    const currentDashboardId = dashboardIds[value];
    console.log('Embedding dashboard with ID:', currentDashboardId); // Add this

    const embedDashboardSubscription = SupersetService.embedDashboard(dashboardIds[value]).subscribe(
      () => {
        console.log('Dashboard embedded successfully');
      },
      (error) => {
        console.error('Error embedding dashboard:', error);
      }
    );

    return () => embedDashboardSubscription.unsubscribe(); // Cleanup subscription on component unmount
  }, [value]); // Re-run effect when the active tab changes

  // Fetch all charts when component mounts
  useEffect(() => {
    const fetchChartsSubscription = SupersetService.fetchCharts().subscribe({
      next: (data) => {
        setChartData(data);
        if (data.length > 0) {
          setSelectedChart(data[0]); // Set default chart if available
        }
        setIsLoading(false);
      },
      error: (err) => {
        console.error('Error fetching charts:', err);
        setError('Failed to fetch charts. Please check your API and token.');
        setIsLoading(false);
      },
    });

    return () => fetchChartsSubscription.unsubscribe();
  }, []);

  // Load chart data when selected chart changes
  useEffect(() => {
    if (selectedChart) {
      const loadChartSubscription = SupersetService.loadChartData(selectedChart.id).subscribe({
        next: (data) => {
          console.log('Chart Data Response:', data); // Debugging response
          if (data && data.form_data) {
            setChartPayload(data);
          } else {
            console.warn('Invalid chart data received:', data);
          }
        },
        error: (error) => {
          console.error('Error loading chart data:', error);
          setError('Failed to load chart data.');
        },
      });

      return () => loadChartSubscription.unsubscribe();
    }
  }, [selectedChart]);


  return (
    <>
      {/* , 'cianacare','Appointments', 'cianalab', 'cianaarex', 'Genetic wellness' */}
        <div className='h-100'>
          <div className="mx-4">
            <div className="grid grid-cols-12">
              <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 sm:text-xs tabsContainers flex-wrap mb-4">
                {['cianahealth', 'cianacare', 'Appointments'].map((tabName, index) => (
                  <div
                    key={index}
                    id={13399 + index}
                    className={`${value === index ? 'activetabs' : 'tabSections'} sm:!text-xs mt-2`}
                    onClick={() => handleChange(index)}
                  >
                    {tabName}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='mx-4' id="superset_embedding_div_class" style={{ height: '80vh' }} />
        </div>

        {/* <div className="chart-container mx-4 mt-4">
        <h2>Superset Charts</h2>

        {chartData.length > 0 && (
          console.log("chartPayload", chartData),

          <select
            className="form-control"
            onChange={(e) => {
              const chart = chartData.find((c) => c.id === Number(e.target.value));
              setSelectedChart(chart);
            }}
            value={selectedChart ? selectedChart.id : ''}
          >
            {chartData.map((chart) => (
              <option key={chart.id} value={chart.id}>
                {chart.slice_name}
              </option>
            ))}
          </select>
        )}

        {isLoading ? (
          <p>Loading charts...</p>
        ) : error ? (
          <p className="error-message">{error}</p>
        ) : (
          chartPayload && (
            console.log("chartPayload", chartPayload),
            <div style={{ width: '100%', height: '500px' }}>
              <SuperChart
                chartType={selectedChart?.viz_type}
                width={600}
                height={400}
                formData={chartPayload.form_data}  // Ensure correct key
                queryData={{ data: chartPayload }}
              />
            </div>
          )
        )}
      </div > */}
      </>
      );
};

      export default SuperSet;
